import fetch from 'isomorphic-fetch';
import { /*API_URL,*/ API2_URL, CONCEPTS_REQUEST, CONCEPTS_COMPLETE, CONCEPTS_SHOW, CONCEPT_EDIT, CONCEPT_FAIL, CONCEPT_UNITS, CONCEPT_CLEAR } from "../store/config";
import { newNotification } from "./notifications";
import { history } from "../store/store";
import _ from 'lodash';
import {sessionService} from "redux-react-session";

/*Concepts Show*/
export const conceptsShow = (page = 1, filters={}) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});

				dispatch(conceptRequest());
				return fetch(`${API2_URL}/expenses/concepts?include[0]=status&page=${page}${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(conceptsData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(conceptFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const conceptsList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(conceptRequest());

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/expenses/concepts?include[0]=status&include[1]=units&per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(conceptsData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(conceptFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/**Fetch Concepts Expenses */
export const fetchConcept = (id) => (dispatch) => {
	dispatch(conceptRequest());
	dispatch(conceptsClear());
	return dispatch(conceptEdit(id))
		.then((concept) => {
			if(!_.isEmpty(concept.payload)){
				return dispatch(conceptComplete())
			}else {
				return dispatch(conceptFail(concept.error))
			}
		})
}

/*Concept Edit*/
const conceptEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/expenses/concepts/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(conceptEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(conceptFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Concept Save*/
export const conceptSave = (values) => (dispatch) => {
	dispatch(conceptRequest());
	return dispatch(conceptEditSave(values))
		.then((concept) => {
			if(!_.isEmpty(concept.payload)){
				if(!_.isEmpty(values.units)){
					return dispatch(unitsConceptEditSave(values, concept.payload.id))
						.then((units) => {
							if(!_.isEmpty(units.payload)){
								if(values.id){
									return dispatch(conceptComplete())
								}
							}else {
								return dispatch(conceptFail(units.error))
							}
						})
				}else {
					return dispatch(conceptComplete())
				}
			}else {
				return dispatch(conceptFail(concept.error))
			}
		})
};

const conceptEditSave = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({name: values.name, status_id: values.status_id})
				};

				return fetch(`${API2_URL}/expenses/concepts${values.id ? `/${values.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							if(_.isEmpty(values.units)){
								dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El concepto de gasto se ha guardado correctamente", type: "success"}));
								if(_.isEmpty(values.id)){
									history.push(`/gastos/conceptos/editar/${json.data.id}`);
								}
							}
							return dispatch(conceptEditData(json))
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(conceptFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

const unitsConceptEditSave = (values, id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				let units = [];

				_.map(values.units, (row) => {
					return units.push({name: row.name, invoiceable: row.invoiceable, status_id: row.status_id})
				})

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({units})
				};

				return fetch(`${API2_URL}/expenses/concepts/${id}/units${values.id ? '?_method=PUT':''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El concepto de gasto se ha guardado correctamente", type: "success"}));
							if(_.isEmpty(values.id)){
								history.push(`/gastos/conceptos/editar/${id}`);
							}
							return dispatch(unitsConceptData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(conceptFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

/*Concept Delete*/
export const conceptDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'DELETE'
				};

				dispatch(conceptRequest());
				return fetch(`${API2_URL}/expenses/concepts/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El Concepto se ha borrado Exitosamente", type: "success"}));
							return dispatch(conceptsShow(json))
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(conceptFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Concepts Show*/
export const conceptsData = (json) => {
	return {
		type:CONCEPTS_SHOW,
		isFetching:false,
		payload:json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions ? json.permissions:[],
		timestamp:Date.now()
	}
};

/*Concept Edit*/
const conceptEditData = (json) => {
	return {
		type: CONCEPT_EDIT,
		//isFetching: false,
		payload: json.data,
		permissions: json.permissions ? json.permissions:[],
		timestamp: Date.now()
	}
};

/*Units Concept List*/
const unitsConceptData = (json) => {
	return {
		type: CONCEPT_UNITS,
		payload: json.data,
		timestamp: Date.now()
	}
}

/*Fetch complete*/
const conceptComplete = () => {
	return {
		type: CONCEPTS_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

/*Concepts Clear*/
const conceptsClear = () => {
	return {
		type: CONCEPT_CLEAR,
		payload: {
			edit: {
				units:[]
			},
			permissions: []
		}
	}
}
/*Concept Fail*/
const conceptFail = (error) => {
	return {
		type: CONCEPT_FAIL,
		isFetching:false,
		error:error,
		timestamp:Date.now()
	}
};

/*Concept Request*/
const conceptRequest = () => {
	return {
		type: CONCEPTS_REQUEST,
		isFetching:true,
		timestamp:Date.now()
	}
};




// WEBPACK FOOTER //
// ./src/actions/concepts.js